import type { FC } from 'react';
import { msg } from '@gonfalon/messages/msg';

import { meta, metaItem, metaMono, metaSep } from '../../internal/components/conversation/ConversationChrome.css';

export interface MessageMetaItem {
  key: string;
  value: string;
  mono?: boolean;
}

export interface MessageMetaProps {
  items: MessageMetaItem[];
  /** Richer hover text (e.g. offset + full ISO time). */
  title?: string;
  className?: string;
}

/**
 * Quiet caption under a conversation card. Callers own the item list so span
 * surfaces can pass rich metrics while Vega may pass only a timestamp.
 * A title-only caption still renders so hover tooltips (e.g. offset) are preserved.
 */
export const MessageMeta: FC<MessageMetaProps> = ({ items, title, className }) => {
  if (items.length === 0 && !title) {
    return null;
  }

  return (
    <div
      className={[meta, className].filter(Boolean).join(' ')}
      aria-label={msg('vega.conversation.metadataLabel')}
      title={title}
    >
      {items.map((item, index) => (
        <span key={item.key} className={[metaItem, item.mono ? metaMono : undefined].filter(Boolean).join(' ')}>
          {index > 0 && (
            <span className={metaSep} aria-hidden>
              ,
            </span>
          )}
          {item.value}
        </span>
      ))}
    </div>
  );
};
